"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import Image from "next/image";
import { motion } from "framer-motion";
import { crmWhyChoose } from "./crm.data";
import GradientButton from "@/components/ui/GradientButton";
import { FaChevronRight } from "react-icons/fa";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
export default function CrmWhyChoose() {
  const $ = _c(36);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.6,
      ease
    };
    t4 = {
      once: true
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t5 = <motion.h2 initial={t0} whileInView={t1} animate={t2} transition={t3} viewport={t4} className="font-poppins mb-5 text-[30px] font-bold leading-[1.3] text-[#0b1354] sm:text-[36px] lg:text-[44px] dark:text-white">Why Choose Us?</motion.h2>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="mx-auto mb-9 max-w-[520px] font-sans text-[16px] leading-[31px] text-[#6b7280] md:text-[17px] lg:mx-0 dark:text-gray-300">Empowering your home services business with innovative, reliable, and user-friendly solutions, we ensure seamless experiences for both service providers and customers.</p>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex justify-center lg:justify-start"><GradientButton href="/contact" variant="peach-pink">Get a Free Consultation <FaChevronRight className="ml-1 text-[12px]" /></GradientButton></div>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== desktopAnimations) {
    t8 = desktopAnimations ? {
      opacity: 0
    } : false;
    $[14] = desktopAnimations;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== desktopAnimations) {
    t9 = desktopAnimations ? {
      opacity: 1
    } : undefined;
    $[16] = desktopAnimations;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== desktopAnimations) {
    t10 = desktopAnimations ? undefined : {
      opacity: 1
    };
    $[18] = desktopAnimations;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      duration: 0.6
    };
    t12 = {
      once: true
    };
    $[20] = t11;
    $[21] = t12;
  } else {
    t11 = $[20];
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t8 || $[24] !== t9) {
    t13 = <div className="mt-11 flex justify-center lg:justify-start"><motion.img initial={t8} whileInView={t9} animate={t10} transition={t11} viewport={t12} src="/images/crm/why-choose.png" alt="Why Choose Us" className="w-full max-w-[520px] animate-[float_4s_ease-in-out_infinite] object-contain" /></div>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13 || $[27] !== t5) {
    t14 = <div className="relative flex flex-col justify-start text-center lg:text-left">{t5}{t6}{t7}{t13}</div>;
    $[26] = t13;
    $[27] = t5;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== desktopAnimations) {
    t15 = crmWhyChoose.map((item, idx) => <motion.div key={item.title} initial={desktopAnimations ? {
      opacity: 0,
      x: 40
    } : false} whileInView={desktopAnimations ? {
      opacity: 1,
      x: 0
    } : undefined} animate={desktopAnimations ? undefined : {
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.5,
      delay: idx * 0.1,
      ease
    }} viewport={{
      once: true
    }} className="relative flex items-center gap-[26px] rounded-[12px] border border-white/60 bg-white/70 px-[26px] py-[26px] shadow-[0_6px_24px_rgba(20,60,100,0.06)] backdrop-blur-md transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_36px_rgba(20,60,100,0.12)] dark:border-gray-700 dark:bg-gray-800/80"><div className="font-poppins absolute top-1/2 -left-[17px] flex h-[34px] w-[34px] -translate-y-1/2 items-center justify-center rounded-full border border-[#ffd0de] bg-white text-[16px] font-bold text-[#141047] shadow-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white">{idx + 1}</div><Image src={item.icon} alt={`${item.title} icon`} width={120} height={120} className="h-[60px] w-[60px] shrink-0 object-contain" /><div><h3 className="font-poppins mb-1.5 text-[20px] font-bold leading-[28px] text-[#0b1354] dark:text-white">{item.title}</h3><p className="font-sans text-[16px] leading-[31px] text-[#6b7280] md:text-[17px] dark:text-gray-300">{item.description}</p></div></motion.div>);
    $[29] = desktopAnimations;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = <div className="flex flex-col gap-[30px] pt-2 pl-4 lg:pt-0 lg:pl-5">{t15}</div>;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t14 || $[34] !== t16) {
    t17 = <section className="bg-gradient-to-b from-[#c7ecff] to-[#f9efff] py-16 md:py-24 px-6 font-sans overflow-hidden dark:from-gray-900 dark:to-gray-950"><div className="max-w-7xl mx-auto"><div className="grid grid-cols-1 items-start gap-12 lg:grid-cols-2 lg:gap-14">{t14}{t16}</div></div></section>;
    $[33] = t14;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  return t17;
}